import { getSessionItem } from '~/services/application.service';
import { fetchData } from '~/services/http.service';
import packageJson from '../../package.json';
import { LOG_MUTATION } from '~/graphql/mutations/application.mutations';
export const log = (message, level, key, logData = []) => {
    const county = getSessionItem('county');
    const username = getSessionItem('username');
    const version = packageJson.version;
    const userLogData = [
        { key: 'county', value: county },
        { key: 'username', value: username },
        { key: 'version', value: version },
        { key: 'app', value: 'phoenix' },
        ...logData,
    ];
    const variables = {
        message,
        level: level.toUpperCase(),
        key,
        client: 'web',
        data: userLogData,
    };
    fetchData(LOG_MUTATION, variables);
};
